"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Search = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Search__clip0__".concat(id) : 'Search__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.5 16.607l5.333 5.34a.668.668 0 01-.026.921l-.934.935a.666.666 0 01-.946 0l-5.334-5.34a3.47 3.47 0 01-.4-.48l-1-1.336a9.326 9.326 0 01-5.826 2.043 9.336 9.336 0 01-9.13-7.257A9.348 9.348 0 015.297.92a9.326 9.326 0 0111.358 2.628 9.353 9.353 0 01-.062 11.67l1.334.922c.208.133.4.29.573.467zM2.7 9.345a6.67 6.67 0 006.667 6.675 6.663 6.663 0 004.714-1.955 6.679 6.679 0 001.952-4.72A6.67 6.67 0 009.367 2.67 6.67 6.67 0 002.7 9.345z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Search = Search;
//# sourceMappingURL=search.js.map